// ============================================================
// Datei: src/hooks/useVolunteers.js
// Zweck:
// - Volunteers eines Departments laden
// - Reload-Funktion für Status-Updates bereitstellen
// ============================================================

import { useState, useEffect, useCallback } from "react";
import Api from "../../Api";

const useVolunteers = (departmentName) => {

    const [volunteers, setVolunteers] = useState([]);

    // ============================================================
    // 🔁 ZENTRALE Ladefunktion (wiederverwendbar)
    // ============================================================
    const loadVolunteers = useCallback(async () => {
        if (!departmentName) return;

        try {
            const response = await Api.get(
                `/volunteers?department=${departmentName}`
            );

            setVolunteers(response.data);

        } catch (error) {
            console.error("Fehler beim Abrufen der Helfer", error);
        }
    }, [departmentName]);

    // ============================================================
    // Initialer Load + bei Department-Wechsel
    // ============================================================
    useEffect(() => {
        loadVolunteers();
    }, [loadVolunteers]);

    // ============================================================
    // API der Hook
    // ============================================================
    return [volunteers, setVolunteers, loadVolunteers];
};

export default useVolunteers;
